import { useMutation } from 'react-query'
import { projectUseCase } from '../../factories'

const useUpdateProject = () => useMutation(projectUseCase.updateProject)

export default useUpdateProject
